import type { BuyerSequenceSelection, BuyerSequenceStepKey } from "@/api/buyerSequence";

/**
 * Query keys for the Buyer Outreach tab. Every read registers here and every
 * mutation invalidates by PREFIX (`staleAfterSaveGate.test.ts`).
 *
 * Wording and call hours are the CURRENT USER's, not the buyer's, so they sit
 * under their own root: a personal-version save must refresh every buyer's
 * rendered messages, which is why a wording mutation invalidates `all`.
 */
export const buyerSequenceKeys = {
  all: ["buyer-sequence"] as const,

  states: () => [...buyerSequenceKeys.all, "state"] as const,
  stateForBuyer: (buyerId: string) => [...buyerSequenceKeys.states(), buyerId] as const,
  state: (
    buyerId: string,
    step: BuyerSequenceStepKey | null,
    selection: BuyerSequenceSelection,
  ) => [...buyerSequenceKeys.stateForBuyer(buyerId), step, selection] as const,

  previews: () => [...buyerSequenceKeys.all, "preview"] as const,
  /** The Edit wording live preview: working blocks rendered on this buyer. */
  preview: (
    buyerId: string,
    templateKey: string,
    blocks: Record<string, string>,
    selection: BuyerSequenceSelection,
  ) => [...buyerSequenceKeys.previews(), buyerId, templateKey, blocks, selection] as const,

  wordings: () => [...buyerSequenceKeys.all, "wording"] as const,
  wording: (templateKey: string) => [...buyerSequenceKeys.wordings(), templateKey] as const,

  fields: () => [...buyerSequenceKeys.all, "fields"] as const,

  callHours: () => [...buyerSequenceKeys.all, "call-hours"] as const,
};
